import { render, staticRenderFns } from "./CsLayout.vue?vue&type=template&id=6f84a5f6"
import script from "./CsLayout.vue?vue&type=script&lang=js"
export * from "./CsLayout.vue?vue&type=script&lang=js"
import style0 from "./CsLayout.vue?vue&type=style&index=0&id=6f84a5f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports